export class ScheduleImportResult {
    Sheet1 : {
        csv: string;
        messages: any;
    }
}


// WEBPACK FOOTER //
// ./src/holiday/models/Schedule.ts